import React from 'react';

function MentionsLegales() {
    return (
        <div>
            <div className="espaceHaut"></div>
            <div className="fondParchemin">
                <h1>Mentions Légales</h1>

                <p>Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance en l'économie numérique, il est précisé aux utilisateurs du site La Clef l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi.</p>

                <h2>Edition du site</h2>

                <p>Le présent site, accessible à l’URL www.laclef.online (le « Site »), est édité par :</p>

                <p>FANELIA SASU , société au capital de 1000 euros, inscrite au R.C.S. de BESANCON sous le numéro 813 452 489, dont le siège social est situé au 31 rue du Renaudumont 25500 Les Fins FRANCE, représenté(e) par Stéphanie Quiquempoix dûment habilité(e)</p>

                <p>Le numéro individuel TVA de l’éditeur est : FR51813452489.</p>

                <h2>Hébergement</h2>

                <p>Le Site est hébergé par la société Gandi, situé 63/65 63 BOULEVARD MASSENA 75013 PARIS, (contact téléphonique ou email : +33170377661).</p>

                <h2>Directeur de publication</h2>

                <p>Le Directeur de la publication du Site est Stéphanie Quiquempoix .</p>

                <h2>Nous contacter</h2>

                <p>Par téléphone : +33620210441<br/>
                Par email : fanelia@faneliart.fr<br/>
                Par courrier : 31 rue du Renaudumont 25500 Les Fins</p>

                <h2>Données personnelles</h2>

                <p>Le traitement de vos données à caractère personnel est régi par notre Charte du respect de la vie privée, disponible depuis la section "Charte de Protection des Données Personnelles", conformément au Règlement Général sur la Protection des Données 2016/679 du 27 avril 2016 («RGPD»).</p>

                <p>Génération des mentions légales par Legalstart.</p>
            </div>
        </div>
    );
}

export default MentionsLegales;
